import { AsyncState, Updater } from 'widgets-for-react';
import * as Api from '../../subscription/subscriptionApi';

export type Invoice = typeof Api.invoiceSampleResponse & {
  InvoiceKind: "Regular" | "Corrective" | "Corrected"
}

export type InvoiceSelectorState = {
  year:number
  invoices:AsyncState<Array<Invoice>>
}

export const initialInvoiceSelectorState = () : InvoiceSelectorState => {
  const initialYear = new Date(Date.now()).getFullYear()
  return ({
    year:initialYear,
    invoices:Api.getInvoices(initialYear)
  })
}

export const invoiceSelectorStateUpdaters = {
  year:(u:Updater<InvoiceSelectorState["year"]>) : Updater<InvoiceSelectorState> =>
    s => {
      const newYear = u(s.year)
      return ({...s, year:newYear, invoices:Api.getInvoices(newYear) })
    },
  invoices:(u:Updater<InvoiceSelectorState["invoices"]>) : Updater<InvoiceSelectorState> =>
    s => ({...s, invoices:u(s.invoices) })
}

